import { decrypt, encrypt } from "@/shared/utils/crypto/crypto";

const storage = {
    set: (
        type: typeof localStorage | typeof sessionStorage,
        key: string,
        data: string
    ): boolean => {
        try {
            type.setItem(btoa(key), encrypt(data));
            return true;
        } catch (error) {
            console.error("Error setting item:", error);
            storage.clear(type);
            return false;
        }
    },

    get: (type: typeof localStorage | typeof sessionStorage, key: string): string | object | null => {
        try {
            const encryptedData = type.getItem(btoa(key));
            if (!encryptedData) {
                return null;
            }
            const decryptedData = decrypt(encryptedData);
            if (decryptedData === null) {
                storage.clear(type);
                return null;
            }
            return decryptedData;
        } catch (error) {
            console.error("Error getting item:", error);
            storage.clear(type);
            return null;
        }
    },

    remove: (type: typeof localStorage | typeof sessionStorage, key: string): boolean => {
        try {
            type.removeItem(btoa(key));
            return true;
        } catch (error) {
            console.error("Error removing item:", error);
            storage.clear(type);
            return false;
        }
    },

    clear: (type: typeof localStorage | typeof sessionStorage): boolean => {
        try {
            type.clear();
            return true;
        } catch (error) {
            console.error("Error clearing storage:", error);
            return false;
        }
    },
};

export default storage;
